"use client"

import { cn } from "@/lib/utils"
import { LoadingSpinner } from "@/components/ui/feedback/loading-spinner"
import { loadingMessageForPage } from "@/lib/utils/page-loading"

type PageLoadingProps = {
  /** Visible page title (e.g. nav label): "Overview", "Motivation", "Investments". */
  pageTitle: string
  className?: string
}

/**
 * Full-route loading state: same spinner + typography as Investments, vertically centered in the viewport band.
 */
export function PageLoading({ pageTitle, className }: PageLoadingProps) {
  return (
    <div
      className={cn(
        "flex w-full flex-1 flex-col items-center justify-center px-4",
        "min-h-[min(75dvh,calc(100dvh-10rem))]",
        className
      )}
    >
      <LoadingSpinner size="lg" text={loadingMessageForPage(pageTitle)} />
    </div>
  )
}
